/**
@ngdoc directive
@name xmsTable

@description
The template inside the table always has to use ngModel.<br />
You need to specify ng-repeat which will be used as it is (so any optimization like 'track by' is up to you).<br />
You need to specify your own ng-form inside the template. You can do it on tbody
    or if you want to specify it on the whole table you need to wrap it into additional element (ie. div or even <xms-table>) and apply the directive on the wrapper
    (so ng-form is always inside the template!).<br />
So as of above - you can specify the directive on the table or on the wrapping element.<br />
You can also ng-repeat ngRemovedModel if you need to pass removed rows info to backend (ie. for locators in Candidate).<br />
    The good practise will be to ng-repeat ngRemovedModel inside tfoot > tr > td element

TODO: custom places for add/remove row buttons (only if required)

@param {Object} ng-model table data (two-way binded)
@param {boolean=} ng-required ngRequired (dynamic now)
@param {boolean=} ng-disabled ngDisabled (you probably want to set ngRequired to false if it's true)
@param {boolean=} ng-add-disabled ngAddDisabled disable the add button if for instance only 10 rows can be added
@param {string=} label table label
@param {Object=} validationMessages required message
@param {boolean} no-box-edge will position tooltip next to label or push it all the way to the right of the label
*/

// TODO: replace button-add button-remove with the code as an option to adding column dynamically

(function() {
    'use strict';

    var xmsTable = function($compile, $timeout, formFieldFactory){

        return({
            restrict: "A", // E would not work for IE8
            scope: {
                ngModel: "=",
                ngRequired: '=?',
                ngDisabled: '=?',
                ngAddDisabled: '=?',
                noBoxEdge: '&',
                label: '@?',
                tooltip: '@?',
                validationMessages: '&?',
                // innerForm: "="
            },
            require: '^form',
            compile: compile
        });


        function compile( tElement, tAttributes ) {

            // store the content of the directive in the variable then remove it
            var htmlContent = tElement.html();
            tElement.html(''); // remove


            return function postLink(scope, element, attrs, form) {

                var container;
                scope.xmsTableModel = {};


                (function initialize(){

                    scope.ngRemovedModel = []; // you can ng-repeat ngRemovedModel if you need to pass removed rows info into backend.

                    scope.ngModel = angular.isDefined(scope.ngModel) ? scope.ngModel : new Array();
                    scope.tableTouched = false;

                    element.wrap('<div class="row xms-widget"></div>');

                    container = element.closest('.xms-widget');
                    var $html = $('<div />',{ html:htmlContent }), // for easier manipulation
                        tbody = $html.find('tbody');

                    // STRUCTURE & label
                    var tableElement;
                    if( element[0].nodeName == 'TABLE'){
                        tableElement = element;
                    } else {
                        tableElement = $html.find('table');
                    }
                    // label
                    if(angular.isDefined(scope.label)){
                        // compile for dynamic required class, or rather to not to place $timeout here
                        var tooltipStr = "";
                        var noBoxEdge = false;
                        if(angular.isDefined(scope.noBoxEdge) && scope.noBoxEdge != '') {
                            noBoxEdge = scope.noBoxEdge;
                        }
                        if(angular.isDefined(scope.tooltip) && scope.tooltip != '') {
                            tooltipStr = ' xms-tooltip="' + scope.tooltip + '" ' + (noBoxEdge ? 'no-box-edge="true"' : '');
                        }
                        tableElement.before( $compile([
                            '<div class="col-md-12">',
                            '<label class="control-label widget-label" ng-class="{required:ngRequired}"' + tooltipStr + '>'+scope.label+'</label>', // ng-class="{required:ngRequired && !ngDisabled}" ??
                            '</div>'].join('') )(scope) );
                    }
                    tableElement.addClass('widget-table') // not sure if 'widget-table' class is needed
                                .wrap('<div class="form-box clearfix" style="margin-bottom:0; clear:both;"></div>')
                                .wrap('<div class="col-md-12"></div>');
                    if( !angular.isDefined(attrs.fixedLayoutTable) || attrs.fixedLayoutTable!="false" ){
                        tableElement.addClass('fixed-layout-table');
                    }


                    // find ng-form
                    var ngFormElement = $html.find('[ng-form]');
                    if(ngFormElement.length){
                        scope.formName = ngFormElement.attr('ng-form');
                    } else {
                        throw "No ng-form found inside the template.";
                    }

                    // add/remove rows elements
                    $html.find('thead tr').append([
                        '<th class="action-col">',
                            '<a ng-disabled="ngDisabled || ngAddDisabled" href="javascript:void(0);" class="btn btn-action btn-action-entity" ng-click="addRow()" role="button" title="Add new row" aria-label="Add new row">',
                                '<span class="glyphicon glyphicon-plus"><span class="sr-only">Add</span></span>',
                            '</a>',
                        '</th>'].join(''));
                    $html.find('tbody tr').append([
                        '<td class="action-col">',
                            '<a ng-disabled="ngDisabled" href="javascript:void(0);" class="link-entity" ng-click="removeRow($index)" role="button" title="Remove row" aria-label="Remove row">',
                                '<span class="aria-hidden">&times</span>',
                            '</a>',
                        '</td>'].join(''));


                    $timeout(function(){

                        // the following is specifically for Revenue Allocation widget, so it could ngRepeat on external data
                        scope.pageModel = scope.$parent.pageModel;
                        // scope.formModel = scope.$parent.formModel;

                        if(scope.ngRequired && scope.ngDisabled){
                            console.warn("xms-table \""+scope.label+"\" is both required and disabled - please mind in this case the validation on the table is off! (So it's not required any more).")
                        }


                        scope.$watch("ngRequired && !ngDisabled", function(newVal, oldVal){
                            if(newVal!=oldVal){
                                if(newVal){
                                    container.addClass("widget-required");
                                } else {
                                    container.removeClass("widget-required");
                                }
                            }
                        });
                        if(scope.ngRequired && !scope.ngDisabled){
                            container.addClass("widget-required");
                        }

                        // VALIDATION
                        scope.$watch(
                            function(scope){
                                return scope.ngModel.length;
                            }, function(newVal, oldVal){
                                scope.xmsTableModel.modelLength = newVal;
                            }
                        );

                        // is there at least one row? the whole form validation based on faux input and scope.ngModel.length
                        tbody.append('<tr class="hidden" ng-if="ngRequired && !ngDisabled"><td><input type="number" min="1" ng-model="xmsTableModel.modelLength"></td></tr>');

                        // validation message based on scope.ngModel.length
                        container.append( $compile([
                            '<div class="col-md-12">',
                                '<span class="widget-error-msg validation-messages">',
                                    '<small class="text-danger" ng-if="ngRequired && !ngDisabled && !ngModel.length">',
                                        angular.isDefined(scope.validationMessages) && angular.isDefined(scope.validationMessages().required) ? scope.validationMessages().required : 'Please provide at least one entry.',
                                    '</small>',
                                '</span>',
                            '</div>'].join('') )(scope) );


                        element.append( $compile( $html.html() )(scope) );

                        // register table form inside parent form
                        formFieldFactory.formRegister(scope[scope.formName], form); // not only if required - we need to prevent invalid entries at all
                        // TODO: unregister on destroy?
                    });

                })(); // () - executes on declaration



                // WATCHES
                // validation success class
                scope.$watch(
                    function(scope){
                        return angular.isDefined(scope[scope.formName]) ? scope[scope.formName].$valid : null;
                    },
                    function(newVal, oldVal){
                        if(newVal != oldVal && newVal!==null){
                            if(newVal){
                                container.addClass('widget-has-success');
                                // container.removeClass('widget-has-error');
                            } else {
                                container.removeClass('widget-has-success');
                                // container.addClass('widget-has-error');
                            }
                        }
                    },
                true);

                // table touched
                scope.$watch(
                    function(scope){
                        return angular.isDefined(scope[scope.formName]) ? (scope[scope.formName].$touched || scope.tableTouched) : null; // this could be such a nice ng-class... ;-)
                    },
                    function(newVal, oldVal){
                        if(newVal != oldVal && newVal!==null){
                            if(newVal){
                                container.addClass('widget-touched');
                                // we could actually remove the watch here (?)
                            } else {
                                // this probably will never occur?
                                container.removeClass('widget-touched');
                            }
                        }
                    },
                true);

                // invalid form in general
                scope.$watch(
                    function(scope){
                        return scope.ngRequired && !scope.ngDisabled && !scope.ngModel.length;
                    },
                    function(newVal, oldVal){
                        if(newVal!=oldVal){
                            if(newVal){
                                container.addClass('widget-has-error');
                            } else {
                                container.removeClass('widget-has-error');
                            }
                        }
                    }
                );



                // Add/remove rows Functions
                scope.addRow = function(){
                    if(!scope.ngDisabled){
                        scope.ngModel.push({});
                    }
                }
                scope.removeRow = function(index){
                    if(!scope.ngDisabled){
                        scope.ngRemovedModel.push( scope.ngModel.splice(index, 1)[0] );
                        scope.tableTouched = true;
                    }
                }


            }
        }
    };
    xmsTable.$inject = ['$compile', '$timeout', 'formFieldFactory'];
    angular.module('app').directive('xmsTable', xmsTable);


}());